import { resetPasswordStyles } from "@insite/content-library/Widgets/ResetPassword/ResetPassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

resetPasswordStyles.passwordGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: 15px;
                    `,
                ],
                "min",
            )}
    `,
};
